import { useQueries } from '@tanstack/react-query';
import { useGetProfileImmigrationDocDetails } from 'src/shared/queries/useGetProfileImmigrationDocDetails';
import { IMMIGRATION_DOC_DETAILS } from '../constants/queryKeys';
import { getProfileImmigrationDocDetails } from 'src/shared/services/fn-api/ImmigrationDocuments';
import { IDependent } from 'src/shared/types/Beneficiary';

export const useImmigrationDocuments = (beneId?: number, dependents?: IDependent[]) => {
  // Fetch beneficiary's immigration documents
  const beneficiaryQuery = useGetProfileImmigrationDocDetails({
    beneId: beneId?.toString(),
    dependentId: '',
    includeDocument: false,
  });

  // Fetch dependents' immigration documents
  const dependentQueries = useQueries({
    queries:
      dependents?.map((dependent) => ({
        queryKey: [IMMIGRATION_DOC_DETAILS, dependent.dependentId],
        queryFn: () =>
          getProfileImmigrationDocDetails({
            beneId: beneId?.toString(),
            dependentId: dependent.dependentId.toString(),
            includeDocument: false,
          }),
        enabled: !!dependent.dependentId,
      })) ?? [],
  });

  const isFetchedDependents = dependents != undefined && dependentQueries.every((query) => query.isFetched);

  return {
    isFetched: beneficiaryQuery.isFetched && isFetchedDependents,
    beneDocuments: beneficiaryQuery.isFetched ? beneficiaryQuery.data ?? [] : [],
    dependentsDocuments: dependentQueries.map((query) => query.data).filter(Boolean),
  };
};
